// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../../../../../../../../../node_modules/less-loader/dist/cjs.js!../../../../../shared/tabs/RulesTab/css/base/RulesContent.base.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Tournament Rules Tab CSS Module
 * Tournament-specific rules content styles
 */
.Nz_w4DdHkuY4PIKquIbZ {
}
._87hBskPURuhViM4nPaT {
}
.y_E1wJnViC20GdDQccWg {
}
.dW4TCbwSPk3DUsVNDq93 {
  padding-top: 4px;
}
.z058dueQVSDJSwFO2Fsv {
  margin-top: 5px;
  font-weight: normal;
  text-align: left;
}
.AmXnxs05EwBZbPD_XWHu {
  white-space: nowrap;
}
.Yz4SclsA5aKFktNSK0lt {
  display: block;
  font-style: italic;
  font-weight: 300;
  padding-top: 4px;
}
.IDb25wCDbKYykP1dmAe3 {
  padding-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/tournaments/tabs/RulesTab/TournamentRulesContent/TournamentRulesContent.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;AAEA;AACA;AAEA;AACA;AAEA;AACA;EAEE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["/**\n * Tournament Rules Tab CSS Module\n * Tournament-specific rules content styles\n */\n.title {\n  composes: title from '../../../../../shared/tabs/RulesTab/css/base/RulesContent.base.module.css';\n}\n.section {\n  composes: section from '../../../../../shared/tabs/RulesTab/css/base/RulesContent.base.module.css';\n}\n.highlightedText {\n  composes: highlightedText from '../../../../../shared/tabs/RulesTab/css/base/RulesContent.base.module.css';\n}\n.list {\n  composes: list from '../../../../../shared/tabs/RulesTab/css/base/RulesContent.base.module.css';\n  padding-top: 4px;\n}\n.description {\n  margin-top: 5px;\n  font-weight: normal;\n  text-align: left;\n}\n.noWrap {\n  white-space: nowrap;\n}\n.italicText {\n  display: block;\n  font-style: italic;\n  font-weight: 300;\n  padding-top: 4px;\n}\n.styledSpan {\n  padding-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `Nz_w4DdHkuY4PIKquIbZ ${___CSS_LOADER_ICSS_IMPORT_0___.locals["title"]}`,
	"section": `_87hBskPURuhViM4nPaT ${___CSS_LOADER_ICSS_IMPORT_0___.locals["section"]}`,
	"highlightedText": `y_E1wJnViC20GdDQccWg ${___CSS_LOADER_ICSS_IMPORT_0___.locals["highlightedText"]}`,
	"list": `dW4TCbwSPk3DUsVNDq93 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["list"]}`,
	"description": `z058dueQVSDJSwFO2Fsv`,
	"noWrap": `AmXnxs05EwBZbPD_XWHu`,
	"italicText": `Yz4SclsA5aKFktNSK0lt`,
	"styledSpan": `IDb25wCDbKYykP1dmAe3`
};
export default ___CSS_LOADER_EXPORT___;
